<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100"
    eight="88"
    viewBox="0 0 100 88"
  >
    <path
      class="cls-1"
      d="M92.69,0H7.31A7.31,7.31,0,0,0,0,7.31V58.69A7.31,7.31,0,0,0,7.31,66H16.5V87.5L38,66H92.69A7.31,7.31,0,0,0,100,58.69V7.31A7.31,7.31,0,0,0,92.69,0ZM17.5,14h54a2.5,2.5,0,0,1,0,5h-54a2.5,2.5,0,0,1,0-5Zm51,35h-51a2.5,2.5,0,0,1,0-5h51a2.5,2.5,0,0,1,0,5Zm12-10h-63a2.5,2.5,0,0,1,0-5h63a2.5,2.5,0,0,1,0,5Zm4-10h-67a2.5,2.5,0,0,1,0-5h67a2.5,2.5,0,0,1,0,5Z"
    />
</svg>


</template>


<script>
export default {
  name: 'icon-speechbubble',
  // props: [],
  // components: {},
  // data () {
  //   return {}
  // },
  // methods: {},
  // computed: {},
}
</script>


<style scoped lang="sass">
// @import index

.cls-1
  fill: #fff


</style>



// WEBPACK FOOTER //
// src/components/icons/icon-speechbubble.vue